import { ClubSearchSelect } from '~/pages/club/components/club-search-select';
import { DistrictSelect } from '~/pages/district/components/district-select';
import { toText } from '../../hooks/useRefereeEligibilities';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from '../query-schema';
import { Input } from '~/components/Input';

export function RefereeListFilter() {
  const { register, values, setValue } = useFilterForm(querySchema.parse);

  function resetClub() {
    setValue('club_name', undefined);
    setValue('club_id', undefined);
  }

  return (
    <Table.Bar>
      <Table.Search
        {...register('search')}
        placeholder="Sök på förnamn, efternamn eller licensnummer..."
        aria-label="Sök"
      />

      <Table.Filter>
        <Table.FilterSection label="Distrikt">
          <DistrictSelect {...register('district_id', { onChange: resetClub })} />
        </Table.FilterSection>

        <Table.FilterSection label="Förening">
          <ClubSearchSelect
            value={values.club_id ? [values.club_name, values.club_id] : undefined}
            query={{ district__id: values.district_id }}
            placeholder="Sök på förening..."
            onChange={v => {
              setValue('club_id', v ? (v[1] as string) : undefined);
              setValue('club_name', v ? v[0] : undefined);
            }}
          />
        </Table.FilterSection>

        <Table.FilterSection label="Behörighet">
          <Input.Select
            {...register('level')}
            aria-label="Behörighet"
            options={[
              ['Visa alla', 'ALL'],
              [toText('D'), 'D'],
              [toText('F'), 'F'],
              [toText('K2'), 'K2'],
              [toText('K1'), 'K1'],
            ]}
          />
        </Table.FilterSection>

        <Table.FilterSection label="Visa?">
          <Input.Select
            {...register('state')}
            aria-label="Visa?"
            options={[
              ['Visa alla', 'ALL'],
              ['Endast aktiva', 'ACTIVE'],
            ]}
          />
        </Table.FilterSection>
      </Table.Filter>
    </Table.Bar>
  );
}
